import { render, staticRenderFns } from "./Impersonal.vue?vue&type=template&id=b8b9d4c8&scoped=true"
import script from "./Impersonal.vue?vue&type=script&lang=js"
export * from "./Impersonal.vue?vue&type=script&lang=js"
import style0 from "./Impersonal.vue?vue&type=style&index=0&id=b8b9d4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b9d4c8",
  null
  
)

export default component.exports